export default theme => ({
  root: {
    display: "flex",
  },
});
